import { J3Onoff } from '@e3dc-react/icons'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { CardMedia, IconButton, Typography } from '@mui/material'
import { Box, Stack } from '@mui/system'
import React from 'react'
import { useDispatch } from 'react-redux'
import { Product } from 'src/Libs/shop/models/system-configuration-components.model'
import { ShopImageThumnbailSizes } from 'src/Libs/shop/types'
import { getImageUrlBySize } from 'src/Libs/shop/utils'
import { removeWarrantyExtension } from 'src/State/ShopQntmSystemConfiguration/ShopQntmSystemConfigurationAction'
import { makeStyles } from 'tss-react/mui'

interface WarrantyProductConfigurationCardProps {
  products: Product[]
  selectedWarrantyExtensionId: string
}

const useStyles = makeStyles()(theme => ({
  mainComponentWrapper: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: '8px',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  spaceBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: '8px',
  },
  icon: {
    color: theme.palette.text.headerTitle,
    transform: 'rotate(90deg) translateY(-12px)',
  },
  productImage: {
    width: '45px',
    maxWidth: '45px',
    height: 'auto',
  },
}))

const WarrantyProductConfigurationCard: React.FC<WarrantyProductConfigurationCardProps> = ({ products, selectedWarrantyExtensionId }) => {
  const { classes } = useStyles()
  const dispatch = useDispatch()
  const { t } = useCustomTranslation()
  const selectedProducts = products.filter(product => product.id === selectedWarrantyExtensionId)

  const handleWarrantyRemove = (): void => {
    dispatch(removeWarrantyExtension())
  }

  return (
    <Box>
      {selectedProducts.map(product => {
        return (
          <Stack key={product.id}>
            {product && product.id !== null && (
              <Typography variant="h5" mt={2}>
                {t('shop.system-configure-card.warranty-component')}
              </Typography>
            )}
            <Box className={classes.mainComponentWrapper}>
              <Box className={classes.spaceBetween}>
                <Box>
                  <CardMedia
                    component="img"
                    image={getImageUrlBySize(product.cover?.media?.thumbnails, ShopImageThumnbailSizes.ExtraSmall)}
                    className={classes.productImage}
                  />
                </Box>
                {product?.translated && (
                  <Typography variant="h4" sx={{ wordBreak: 'break-all' }}>
                    {product.translated.name}
                  </Typography>
                )}
              </Box>
              <IconButton
                onClick={() => {
                  handleWarrantyRemove()
                }}
              >
                <J3Onoff fontSize="large" className={classes.icon} />
              </IconButton>
            </Box>
          </Stack>
        )
      })}
    </Box>
  )
}

export default WarrantyProductConfigurationCard
